import translations from '../translations';

const languageShort = (language: any) => language.split(/[-_]/)[0];

export { languageShort };
export default translations;
